import React from "react";
import advanceLead from "../../assets/images/prospecting-search/advance-lead.png";
import aiDriven from "../../assets/images/prospecting-search/AI-driven.png";
import seamlessEmail from "../../assets/images/prospecting-search/seamless-email-integration.png";
import oneClickEngagement from "../../assets/images/prospecting-search/oneClickEngagement.png";
import realTimeTracking from "../../assets/images/prospecting-search/real-time-tracking.png";

const benefits = [
  {
    icon: advanceLead,
    title: "Advanced Lead Discovery",
    desc: "Tap into a vast database of prospects, filtered by industry, location, job title, and more, ensuring you target the right people.",
  },
  {
    icon: aiDriven,
    title: "AI-Driven Recommendations",
    desc: "Leverage AI to identify prospects most likely to convert based on their behavior, demographics, and engagement history.",
  },
  {
    icon: seamlessEmail,
    title: "Seamless Email Integration",
    desc: "Directly import your prospects into the email marketing tool and start crafting personalized campaigns in minutes.",
  },
  {
    icon: oneClickEngagement,
    title: "One-Click Engagement",
    desc: "Send tailored emails or start automated sequences with a single click, saving time and ensuring consistency.",
  },
  {
    icon: realTimeTracking,
    title: "Real-Time Tracking",
    desc: "Monitor email opens, click-throughs, and replies to refine your approach and enhance campaign effectiveness.",
  },
];

const Benefits = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100" id="prospecting-benefits">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Why Choose Us
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Why Choose Our Prospecting Search Tool?
          </h2>
        </div>

        {/* Card Grid */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8">
          {benefits.map((item, idx) => {
            // Check if it's one of the last two items to center them on large displays if needed,
            // but a standard responsive grid works beautifully automatically.
            const isLastRow = idx >= 3;
            return (
              <div
                key={idx}
                className={`tw-group tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col ${
                  isLastRow ? "lg:tw-col-span-1" : ""
                }`}
              >
                {/* Ghost Watermark Icon */}
                <img
                  src={item.icon}
                  alt=""
                  className="tw-absolute tw-bottom-[-16px] tw-right-[-16px] tw-w-28 tw-h-28 tw-opacity-[0.06] tw-pointer-events-none"
                />

                {/* Icon Container */}
                <div className="tw-w-14 tw-h-14 tw-rounded-2xl tw-bg-[#EEF2FF] tw-border tw-border-solid tw-border-[#C7D2FE] tw-flex tw-items-center tw-justify-center tw-mb-6">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="tw-w-7 tw-h-7 tw-object-contain"
                    loading="lazy"
                  />
                </div>

                {/* Text content */}
                <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
                  {item.title}
                </h3>
                <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default Benefits;
